import {
  Button,
  Image,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { t } from "i18next";
import React from "react";
import { AssignJobSteps } from "./AssignJob.types";
import { translations } from "../../i18n/translations";
import { JobInfo } from "./components/JobInfo";
import { TStatics } from "../../api/modules/Statics/types";
import { TJob } from "../../api/modules/Jobs/types";
import { TTeam, TTeamMember } from "../../api/modules/Team/types";
import { UserSelection } from "./components/UserSelection";
import { ResultScreen } from "./components/ResultScreen";
import HeaderImage from "./assets/assign-job-header.png";
import { MakeOfferFormType } from "../Jobs/AvailableJobs/components/MakeOfferModal/MakeOfferModal.types";

type Props = {
  currentTeamMemberData?: TTeamMember;
  currentUser?: number;
  isOpen: boolean;
  isReassignMode?: boolean;
  isLoadingJob: boolean;
  onClose: () => void;
  onAccept: () => void;
  onSetCurrentUser: (userId: number) => () => void;
  onAssignJob: () => void;
  step: AssignJobSteps;
  statics?: TStatics;
  team?: TTeam;
  job?: TJob;

  makeOfferData?: MakeOfferFormType | undefined;
};

export const AssignJobPresentation = (props: Props) => {
  const {
    currentUser,
    currentTeamMemberData,
    isOpen,
    statics,
    job,
    step,
    isReassignMode,
    isLoadingJob,
    makeOfferData,
    team,
    onClose,
    onAccept,
    onSetCurrentUser,
    onAssignJob,
  } = props;
  const screen = translations.screens.assignJob;

  return (
    <>
      <Modal isOpen={isOpen} size="xl" onClose={onClose}>
        <ModalOverlay />
        <ModalContent width="1200px">
          <ModalHeader mt={7} px={7}>
            <Flex alignItems="center" justifyContent="space-between">
              {step === AssignJobSteps.Details && (
                <Flex flexDirection="column">
                  <Text fontSize="lg">{t<string>(screen.details.title)}</Text>
                </Flex>
              )}
              {step === AssignJobSteps.UserSelection && !isLoadingJob && (
                <Text fontSize="xl">
                  {t<string>(
                    screen.userSelection[
                      isReassignMode ? "reassignTitle" : "title"
                    ]
                  )}
                </Text>
              )}
            </Flex>
            {step !== AssignJobSteps.UserSelection && (
              <Image mt={5} src={HeaderImage} />
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody mb={5} px={7}>
            {isLoadingJob ? (
              <Flex justifyContent="center" my={4}>
                <Spinner />
              </Flex>
            ) : (
              <>
                {step === AssignJobSteps.Details && (
                  <JobInfo job={job} statics={statics} />
                )}
                {step === AssignJobSteps.UserSelection && (
                  <UserSelection
                    currentUser={currentUser}
                    isReassignMode={isReassignMode}
                    team={team}
                    onAssign={onAssignJob}
                    onSetCurrentUser={onSetCurrentUser}
                  />
                )}
                {step === AssignJobSteps.Result && (
                  <ResultScreen person={currentTeamMemberData} />
                )}
              </>
            )}
            {step === AssignJobSteps.Details && !isLoadingJob && (
              <Flex justifyContent="flex-end" mt={4}>
                <Button
                  colorScheme={
                    makeOfferData?.price != null && makeOfferData?.price > 0
                      ? "gray"
                      : "nosPurple"
                  }
                  variant={
                    makeOfferData?.price != null && makeOfferData?.price > 0
                      ? "outline"
                      : "solid"
                  }
                  onClick={onAccept}
                >
                  {t<string>(
                    makeOfferData?.price != null && makeOfferData?.price > 0
                      ? screen.details.viewOrUpdateOffer
                      : job?.totalAmountPaid === 0
                      ? screen.details.makeOffer
                      : screen.details.acceptJob
                  )}
                </Button>
              </Flex>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
